export const metrics = {
  HORSE_POWER: 'h.k.',
  LITER: 'liter',
  KM: 'km',
  KG: 'kg',
  KWH: 'kWh',
  KW: 'kW',
  KR: 'kr'
};